import { appRoutes } from "./AppRoutesConfig";
import { PageSection } from "view/About/AboutPageModel";

export const sectionNavigation = {
  [appRoutes.about]: {
    titleKey: "view.about.aboutDSU.button",
    sections: [
      { id: PageSection.ORGANIZE, titleKey: "view.about.aboutDSU.navButtons.organize" },
      { id: PageSection.ATTRIBUTIONS, titleKey: "view.about.aboutDSU.navButtons.attributions" },
      { id: PageSection.MISSION, titleKey: "view.about.aboutDSU.navButtons.mission" },
      { id: PageSection.PERSONNEL, titleKey: "view.about.aboutDSU.navButtons.personnel" },
      { id: PageSection.PROJECTS, titleKey: "view.about.aboutDSU.navButtons.projects" },
      { id: PageSection.PARTNERS, titleKey: "view.about.aboutDSU.navButtons.partners" },
      { id: PageSection.REPORTS, titleKey: "view.about.aboutDSU.navButtons.reports" },
      { id: PageSection.MANAGEMENT, titleKey: "view.about.aboutDSU.navButtons.management" },
    ],
  },
  [appRoutes.dialog]: {
    titleKey: "components.header.dialog",
    sections: [
      { id: "carousel-section", titleKey: "view.navButtons.campaigns" },
      { id: "volunteer-section", titleKey: "view.navButtons.volunteer" },
      { id: "cards-section", titleKey: "view.navButtons.internship" },
      { id: "collab-section", titleKey: "view.navButtons.colabs" },
      { id: "titles-section", titleKey: "view.navButtons.law" },
      { id: "products-section", titleKey: "view.navButtons.products" },
    ],
  },
};
